import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import _get from 'lodash/get';
import getHostDomain from 'helpers/getHostDomain';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import samlInit from 'helpers/samlInit';

const styles = theme => {
  return {
    button: {
      display: 'block',
      marginBottom: theme.spacing(2),
      textTransform: 'none',
      backgroundColor: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        boxShadow: '0px 3px 3px 1px rgba(33, 33, 33, 0.2)',
      },
      width: '100%',
      height: 70,
      boxShadow: '0 1px 3px 0 rgba(33, 33, 33, 0.2)',
    },

    icon: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(2),
    },
    text: {
      textAlign: 'left',
    },
    displayName: {
      fontWeight: 600,
      letterSpacing: 0.3,
      color: theme.palette.primary.dark,
      fontSize: 21,
      lineHeight: '1.46429em',
      [theme.breakpoints.down('xs')]: {
        fontSize: 21,
      },
    },
    subdomain: {
      color: theme.palette.grey[800],
      marginBottom: theme.spacing(1),
      fontSize: 17,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  };
};

class DomainButton extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    loginOptionResponse: PropTypes.object.isRequired,
    loginOptionResponseIndex: PropTypes.number.isRequired,
    history: PropTypes.object,
    additionalParams: PropTypes.object,
  };

  handleRoute = () => {
    const { loginOptionResponseIndex, loginOptionResponse, history } = this.props;

    const preferredMethods = _get(loginOptionResponse.loginOptions, 'preferredMethods', []);
    const otherMethods = _get(loginOptionResponse.loginOptions, 'otherMethods', []);
    const allLoginOptions = preferredMethods.concat(otherMethods);

    if (allLoginOptions.length === 1) {
      if (allLoginOptions[0] === 'saml') {
        this.samlSubmit();
      } else if (allLoginOptions[0] === 'standard') {
        history.push(`/standard/${loginOptionResponseIndex}`);
      }
    } else {
      history.push(`/sign-in/${loginOptionResponseIndex}`);
    }
  };

  samlSubmit = () => {
    const { loginOptionResponse, additionalParams } = this.props;

    samlInit(loginOptionResponse, additionalParams);
  };

  render() {
    const { classes, loginOptionResponse } = this.props;
    const hostDomain = getHostDomain();

    return (
      <Button
        color="secondary"
        size="large"
        className={classes.button}
        key={loginOptionResponse.subdomain}
        onClick={this.handleRoute}
      >
        <div>
          <div className={classes.text}>
            <Typography className={classes.displayName}>
              {loginOptionResponse.displayName}
            </Typography>
            <Typography className={classes.subdomain} variant="caption">
              {loginOptionResponse.subdomain}.{hostDomain}.com
            </Typography>
          </div>
        </div>
      </Button>
    );
  }
}

export default withStyles(styles)(DomainButton);
